export default __webpack_public_path__ + "static/media/fuel-card-inactive.e30b5e23.svg";